export default function (str) {
    const tmp = document.implementation.createHTMLDocument('')
    tmp.body.innerHTML = str
    return tmp.body.childNodes
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/parseHTML.js